import { createSlice } from '@reduxjs/toolkit'



const initialState = {
    selectedLanguage:'en',
    sideInfoOpen:false,
    currentScreen: 'xs' //xs,sm,md,lg,xl
}

const width = document.body.clientWidth;
if (width < 576) {
    initialState.currentScreen = 'xs';
}
else if (width >= 576 && width < 768) {
    initialState.currentScreen = 'sm';
}
else if (width >= 768 && width < 992) { 
    initialState.currentScreen = 'md';
}
else if (width >= 992 && width < 1200) {    
    initialState.currentScreen = 'lg';
}
else if (width >= 1200) {
    initialState.currentScreen = 'xl';
}

// add language value to local storage
const storedLanguage = localStorage.getItem('selectedLanguage');
if (storedLanguage) {
    initialState.selectedLanguage = storedLanguage;
}


export const viewSlice = createSlice({
  name: 'view',
  initialState: {...initialState},
  reducers: {
    changeView: (state,action)=>{
        state.sideInfoOpen = action.payload.sideInfoOpen;
    },
    changeLanguage: (state,action)=>{
        state.selectedLanguage = action.payload.selectedLanguage;
        //change language value in local storage
        localStorage.setItem('selectedLanguage', action.payload.selectedLanguage);
        document.documentElement.lang = action.payload.selectedLanguage; // Set the lang attribute on the html element
    },
    changeScreen: (state,action)=>{
        state.currentScreen = action.payload.currentScreen;
    }
  },
})

// Action creators are generated for each case reducer function
export const { changeView, changeLanguage,changeScreen} = viewSlice.actions

export default viewSlice.reducer